import Signup from './container';

export default Signup;



// WEBPACK FOOTER //
// ./src/routes/SignupTemp/index.js